export const TikTok = () => (
  <svg viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="currentColor"
      d="M36.4,22.8v-4.6c-6-0.3-6.2-5.7-6.2-6.2v-0.1h-4.7v17.9l0,0c0,2-1.6,3.7-3.7,3.7c-2,0-3.7-1.6-3.7-3.7
	c0-2,1.7-3.7,3.7-3.7c0.4,0,0.7,0.1,1.1,0.2v-4.7c-4.5-0.6-8.7,2.6-9.3,7.2c-0.6,4.5,2.6,8.7,7.2,9.3c4.5,0.6,8.7-2.6,9.3-7.2
	c0.1-0.5,0.1-0.9,0.1-1.4v-8.8C32.4,22.6,36.4,22.8,36.4,22.8z"
    />
  </svg>
)
